"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInject = exports.AppContext = void 0;
var react_1 = require("react");
exports.AppContext = react_1.createContext(null);
var useInject = function (name) {
    var container = react_1.useContext(exports.AppContext);
    if (!container) {
        throw new Error('You have forgotten to wrap app to iocContext.Provider');
    }
    // @ts-ignore
    return container.get(name);
};
exports.useInject = useInject;
